var map = {
	"./banner1协会工作手机端.jpg": "9423",
	"./banner2关于我们 手机端.jpg": "d4bf",
	"./banner3优秀成果 手机端.jpg": "b92b",
	"./banner4行业动态 手机端.jpg": "d1a7",
	"./人才建设 手机端.jpg": "9fef",
	"./会员天地 手机端.jpg": "c76b",
	"./党建园地 手机端.jpg": "ec97",
	"./政策法规 手机端.jpg": "0f61",
	"./行业自律.jpg": "2fe2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8a8";